
import CoursePriceList from '@/views/App/Course/SocioTherapyCoaching/PriceList.vue';

const routesCourseSocioTherapyCoaching = [
    {
        path: 'list',
        name: 'courseSocioTherapyCoachingPriceList',
        component: CoursePriceList
    },
];

export default routesCourseSocioTherapyCoaching;